module.exports = __webpack_public_path__ + "static/img/slide-3-image@3x.d129fc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo/slide-3-image@3x.jpg
// module id = i0Dm
// module chunks = 6